"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const KeyboardArrowIcon = ({ isOpen, className, style, }) => {
    const theme = (0, styles_1.useTheme)();
    return isOpen ? (react_1.default.createElement("img", { src: `${theme.baseMediaUrl}/v1/icons-small-default-arrow-collapse.svg`, alt: "arrow down", className: className, style: style })) : (react_1.default.createElement("img", { src: `${theme.baseMediaUrl}/v1/icon-small-arrow-expand.svg`, alt: "arrow up", className: className, style: style }));
};
KeyboardArrowIcon.defaultProps = {
    className: '',
    style: {},
};
exports.default = KeyboardArrowIcon;
